import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const TextDecorationSelector = ({
  value,
  onChange,
}) => {
  return (
    <FormSelect
      label="Text Decoration"
      value={value || 'initial'}
      onChange={onChange}
      options={
        [
          { label: 'initial', value: 'initial' },
          { label: 'line through', value: 'line-through' },
          { label: 'over line', value: 'overline' },
          { label: 'underline', value: 'underline' }
        ]
      }
    />
  )
}

TextDecorationSelector.propTypes = {}
TextDecorationSelector.defaultProps = {}

export default TextDecorationSelector



// WEBPACK FOOTER //
// ./src/components/forms/TextDecorationSelector.js